@let dashboardViewRegions = dashboardViewRegions$ | async;
@let firstLevelViewRegion = firstLevelViewRegion$ | async;
@let secondLevelViewRegions = secondLevelViewRegions$ | async;
@let secondLevelViewRegion = secondLevelViewRegion$ | async;


<div class="study-view-regions">
  <div class="study-view-regions__first-level">
    @for (viewRegion of dashboardViewRegions; track viewRegion.id) {
      <div
        class="study-view-regions__first-level-region"
        [ngClass]="{'study-view-regions__first-level-region_active': viewRegion?.id === firstLevelViewRegion?.id}"
        (click)="setActiveSection(viewRegion)"
      >
        {{ viewRegion?.name }}
      </div> |
    }
  </div>

  @if (secondLevelViewRegions?.length) {
    <div class="study-view-regions__second-level">
      <app-dashboard-study-carousel
        [carouselItems]="secondLevelViewRegions"
        [activeSlideId]="secondLevelViewRegion?.id"
        (slideChanged)="setActiveSection($event)"
      ></app-dashboard-study-carousel>
    </div>
  }
</div>



